import { useHubApi } from '@infl-ts/util-use-hub-api';
import { Autocomplete } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { pipe } from 'fp-ts/function';
import { useState } from 'react';
import { Groups } from './codecs';
import CustomTextField from './custom-text-field';
import { jsx as _jsx } from "react/jsx-runtime";

var GroupAutocomplete = function GroupAutocomplete(_ref) {
  var disabled = _ref.disabled,
      setGroup = _ref.setGroup;

  var _useState = useState(''),
      filterValue = _useState[0],
      setFilterValue = _useState[1];

  var groups = pipe(useHubApi({
    url: '/targeting/groups/search',
    method: 'get',
    outputCodec: Groups,
    params: {
      query: filterValue
    },
    dependencyList: [filterValue]
  }), DE.map(function (x) {
    return x.results;
  }));
  var isLoading = DE.isPending(groups) || DE.isRefresh(groups);
  return /*#__PURE__*/_jsx(Autocomplete, {
    onChange: function onChange(_event, newValue) {
      setGroup(newValue);
      setFilterValue('');
    },
    disabled: disabled,
    loading: isLoading,
    onInputChange: function onInputChange(_event, newInputValue) {
      setFilterValue(newInputValue || '');
    },
    options: DE.isSuccess(groups) ? groups.value.right : [],
    noOptionsText: "No groups match your search",
    getOptionLabel: function getOptionLabel(group) {
      return group.name;
    },
    isOptionEqualToValue: function isOptionEqualToValue(option, group) {
      return option.name === group.name;
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_jsx(CustomTextField, {
        params: params,
        loading: isLoading
      });
    },
    size: "small",
    selectOnFocus: true,
    clearOnBlur: true,
    disablePortal: true,
    "data-element": "Autocomplete",
    "data-component": "GroupAutocomplete",
    "data-source-file": "index.tsx"
  });
};

export default GroupAutocomplete;